import styled from 'styled-components';
import logoutBtn from '@src/assets/icons/icon-logout.svg';
import profile from '@src/assets/icons/icon-profil.svg';
import iconProfileArrowLeft from '@src/assets/icons/icon-profil-arrow-left.svg';
import { confirmDialog, CustomImage, CustomPopover, Text, useText } from '../index';
import { NavLink, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {DeleteAllCache, persistLogin} from '@src/utils/utils';
import { resetCurrentUser } from '@src/store/slice/userSlice';

const AvatarContent = styled.div`
  .content {
    display: flex;
    flex-direction: column;
    width: 248px;
    font-family: UbuntuMedium, sans-serif;

    .name {
      font-size: 16px;
      font-weight: 600;
      border-bottom: 1px solid #dee2e6;
      padding: 25px 0 13px 24px;

      .user-name {
        font-size: 13px;
        font-weight: normal;
        color: #6c757d;
        font-family: UbuntuRegular, sans-serif;
        letter-spacing: -0.2px;
      }
    }

    .profile {
      display: flex;
      padding: 10px 0 13px 24px;
      border-bottom: 1px solid #dee2e6;
      color: #343a40;
      font-size: 14px;
      letter-spacing: -0.22px;
      font-weight: 500;
    }

    .profile:hover {
      background-color: #e9ecef;
    }

    .logout {
      display: flex;
      width: 100%;
      background-color: white;
      border: none;
      padding: 16px 0 21px 24px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #495057;
    }

    .logout:hover {
      background-color: #e9ecef;
    }
  }
`;

const CustomNavLink = styled(NavLink)`
  text-decoration: none;
`;

const ProfilePopover = ({ children, isProfilePopoverVisible, setIsProfilePopoverVisible }) => {
  const { currentUser } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const safeExitMessageLanguage = useText('safeExitMessage');
  const { isAdmin, adminToken } = useSelector((state) => state?.auth);
  const history = useHistory();

  const doLogin = async () => {
    history.push(`/redirect`);
  };

  const safeExit = (e) => {
    e.preventDefault();
    confirmDialog({
      title: <Text t="attention" />,
      message: safeExitMessageLanguage,
      onOk: async () => {
        dispatch(resetCurrentUser());
        if(isAdmin){
          history.push(`/admin/login`);
        }else{
          await persistLogin(dispatch, false);
        }
      },
    });
  };

  const avatarPopoverContent = (
    <AvatarContent>
      <div className="content">
        <div className="name">
          {`${currentUser?.name} ${currentUser?.surName}`}
          <div className="user-name">{currentUser?.userName}</div>
        </div>
        <CustomNavLink
          to={isAdmin ? '/admin/profile' : '/profile'}
          onClick={() => setIsProfilePopoverVisible(false)}
        >
          <div className="profile">
            <CustomImage src={profile} style={{ marginRight: '10px' }} />
            <Text t="myProfile" />
          </div>
        </CustomNavLink>
        {adminToken && (
          <div style={{ cursor: 'pointer' }} onClick={() => doLogin()}>
            <div className="profile">
              <CustomImage src={iconProfileArrowLeft} style={{ marginRight: '10px' }} />
              <span>Admin'e Dön</span>
            </div>
          </div>
        )}
        <button className="logout" onClick={safeExit}>
          <CustomImage src={logoutBtn} style={{ marginRight: '8px' }} />
          <Text t="safeExit" />
        </button>
      </div>
    </AvatarContent>
  );

  return (
    <CustomPopover
      placement="bottomRight"
      title={false}
      content={avatarPopoverContent}
      trigger="click"
      visible={isProfilePopoverVisible}
      arrowPointAtCenter={true}
      onVisibleChange={(value) => {
        setIsProfilePopoverVisible(value);
      }}
    >
      {children}
    </CustomPopover>
  );
};

export default ProfilePopover;
